import { forwardRef, Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { appSettings } from 'app/appSettings';
import { UserContextLoadAction } from 'app/core/store/session/user-context/user-context.actions';
import { UserContext } from 'app/core/store/session/user-context/user-context.interface';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import * as fromRoot from '../store';
import { BaseGuard } from './base.guard';
import { goAction } from '../store/router/router.actions';
import { map } from 'rxjs/operators';
import { DependencyTreeCanActivate } from './dependency-tree.guard';
import { AuthenticatedGuard } from './authenticated.guard';
import { UserContextService } from '../services/user-context.service';

@Injectable({ providedIn: 'root' })
export class UserContextLoadGuard extends BaseGuard<UserContext> implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store, private userContextService: UserContextService) {
    super('UserContextLoadGuard');
    this.store = store;
  }

  getState(): Observable<UserContext> {
    return this.store.pipe(map(state => state.session.userContext));
  }

  hasFailed(t: UserContext): boolean {
    return t.contextFailed;
  }

  isLoaded(t: UserContext): boolean {
    return t.contextLoaded;
  }

  isLoading(t: UserContext): boolean {
    return t.contextLoading;
  }

  loader(T: UserContext, paramMap: { [p: string]: string }): void {
    logger.debug('In UserContextLoadGuard loader (dispatch)');
    this.userContextService.loadOnce();
  }

  resetter(params: { [p: string]: string }): void {}

  versionChecker(t: UserContext, params: { [p: string]: string }): boolean {
    return true;
  }

  navigateAway(): void {
    this.store.dispatch(goAction({ path: appSettings.PUBLIC_PAGE_ROUTE }));
  }

  getDependencies(): any {
    return [AuthenticatedGuard];
  }

  getDependencyRouteData(): any {
  }
}
